import type { ReactElement } from 'react';

/** While a Games page's data is on its way. */
export function GamesLoading(): ReactElement {
  return (
    <div className="fg-wrap" aria-busy="true">
      <div className="fg-empty" role="status">
        Loading games…
      </div>
    </div>
  );
}

/** A Games page whose data did not come: what failed, and a way to try again. */
export function GamesLoadFailed({
  what,
  onRetry,
  withTitle = false,
}: {
  what: 'Games' | 'Search' | 'This genre' | 'This game' | 'These games';
  onRetry: () => void;
  withTitle?: boolean;
}): ReactElement {
  return (
    <div className="fg-wrap">
      {withTitle && (
        <header className="fg-page-head">
          <h1 className="fg-large-title">Games</h1>
        </header>
      )}
      <div className="fg-empty" role="alert">
        <p className="fg-empty__title">{what} didn’t load.</p>
        <p>Check your connection, then try again.</p>
        <p>
          <button type="button" className="fg-play fg-play--large" onClick={onRetry}>
            Try again
          </button>
        </p>
      </div>
    </div>
  );
}
